module.exports = __webpack_public_path__ + "static/img/chat-search-no-message.12fcffd6.png";